import AOS from 'aos';
import debounce from '../helpers/debounce';

const refreshDebounceMs = 100;

/**
 * AOS caches every element's document offset once, at init. It only
 * recalculates on `resize` / `orientationchange`, or when its own
 * MutationObserver sees an injected node that itself carries `[data-aos]`
 * (see `containsAOSNode` in aos/src/js/libs/observer.js).
 *
 * Third-party embeds break both assumptions: Okendo reviews, SearchSpring
 * recommendations and friends render at ~0 height and then grow by thousands
 * of pixels, pushing every section below them down. The injected markup has no
 * `[data-aos]` on it, so AOS never refreshes and the sections after the embed
 * animate against stale offsets.
 *
 * Watching the document height covers every one of those embeds without
 * hooking into any single vendor's load event. AOS animations only touch
 * `opacity` and `transform`, so a refresh can never feed back into a resize.
 */
export default function initAOS() {
  if (Shopify.designMode) {
    return;
  }

  AOS.init({ duration: 1200 });

  if (typeof ResizeObserver === 'undefined') {
    return;
  }

  const observer = new ResizeObserver(
    debounce(() => AOS.refresh(), refreshDebounceMs),
  );

  observer.observe(document.body);
}
